import { FormControlLabel, FormControl } from "@mui/material";
import type { ChangeEventHandler } from "react";
import { useId } from "react";
import { CUSTOM_COMPONENTS } from "@rmh/ui-config/src/themeConfig";
import { useController, useFormContext } from "react-hook-form";
import type { SwitchProps } from "@mui/material/Switch";
import Switch from "../common/Switch";

interface FormSwitchProps extends SwitchProps {
  className?: string;
  name: string;
  label?: string;
  labelPlacement?: "start" | "bottom" | "top" | "end" | undefined;
  fontStyle?: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
}

export const FormSwitch: React.FC<FormSwitchProps> = ({
  className,
  name,
  label = "",
  labelPlacement = "start",
  fontStyle = ".subtitle-l",
  onChange,
}) => {
  const id = useId();

  const { control } = useFormContext();

  const {
    field: { onChange: onFieldChange, value },
  } = useController({
    name,
    control,
  });

  const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    onFieldChange(e);
    onChange?.(e);
  };

  return (
    <FormControl
      className={className ?? "flex flex-1 flex-col text-sm font-medium"}
      id={id}
    >
      <FormControlLabel
        className="ml-0 flex justify-between gap-2 pr-3"
        control={
          <Switch
            checked={value as boolean}
            color="primary"
            name={name}
            onChange={handleChange}
            value={value as boolean}
          />
        }
        label={label}
        labelPlacement={labelPlacement}
        sx={{
          ".MuiTypography-root": CUSTOM_COMPONENTS[fontStyle] as {
            fontSize: string;
            lineHeight: string;
            fontWeight: string;
          },
        }}
        value={label}
      />
    </FormControl>
  );
};
